import { render, staticRenderFns } from "./DeviceManagement.vue?vue&type=template&id=2fa33a03"
import script from "./DeviceManagement.vue?vue&type=script&lang=js"
export * from "./DeviceManagement.vue?vue&type=script&lang=js"
import style0 from "./DeviceManagement.vue?vue&type=style&index=0&id=2fa33a03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports